<template>
  <div class="app-header" id="appHeader">
    <div class="top-header-section">
      <b-container class="top-header">
        <div class="content">
          <div class="register-action" v-if="!isLoggedIn">
            <a class="cursor-pointer" @click="goToPage('/register')">
              Register
            </a>
          </div>
          <div class="login-action" v-if="!isLoggedIn">
            <a class="cursor-pointer" @click="goToPage('/login')"> Login </a>
          </div>
          <div class="profile-action" v-if="isLoggedIn">
            <b-dropdown
              id="profile-dropdown"
              class="m-md-2"
              :text="
                getUserDetail
                  ? `Hi, ${getUserDetail.name.split(' ')[0]}`
                  : 'Profile'
              "
            >
              <b-dropdown-item v-if="isAdmin === false">
                <a class="cursor-pointer" @click="goToPage('/progress')">
                  Quiz Progress
                </a>
              </b-dropdown-item>
              <b-dropdown-item>
                <a class="cursor-pointer" @click="goToPage(accountLink)">
                  {{ accountCaption }}
                </a>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="getUserDetail.role !== 'admin'"
                to="/rewards"
              >
                Reward Points: {{ getUserDetail.rewards }}
              </b-dropdown-item>
              <b-dropdown-item @click="logout">Logout</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </b-container>
    </div>
    <div class="bottom-header-section app-bg-blue">
      <b-container class="bottom-header scrolledHeader">
        <div class="content">
          <div class="app-logo">
            <img :src="appLogo" @click="routeToHome()" alt="" />
          </div>
          <div class="app-nav-wrapper">
            <b-nav>
              <b-nav-item :href="`${appRedirectLink}/learn/`">
                Learn
              </b-nav-item>
              <b-nav-item :href="`${appRedirectLink}#releases`">
                Articles
              </b-nav-item>
              <b-nav-item :href="`${appRedirectLink}#learningpath`">
                Learning Path
              </b-nav-item>
              <b-nav-item :href="`${appRedirectLink}#explore-topic`">
                Topics
              </b-nav-item>
            </b-nav>
          </div>
        </div>
      </b-container>
    </div>
    <OverlayModal :isOpen="showLoginModal">
      <Login :modelValue="showLoginModal" @closeModal="closeModal" />
    </OverlayModal>
  </div>
</template>

<script>
import logo from "@/assets/img/logo.svg";
import OverlayModal from "@/components/OverlayModal";
import Login from "@/components/Login.vue";
export default {
  name: "AppHeader",
  components: { Login, OverlayModal },
  data() {
    return {
      appLogo: logo,
      isScrolled: false,
      showLoginModal: false,
      appRedirectLink: process.env.VUE_APP_ROOT_LINK,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["auth/getLoggedInState"];
    },
    getUserDetail() {
      return this.$store.getters["auth/getUserDetailState"];
    },
    accountCaption() {
      return this.getUserDetail.role !== "admin"
        ? "My Account"
        : "Admin Section";
    },
    accountLink() {
      return this.getUserDetail.role !== "admin" ? "/account" : "/admin";
    },
    isAdmin() {
      return this.getUserDetail.role === "admin";
    },
  },
  mounted() {
    // this.setHeaderProperty()
  },
  methods: {
    routeToHome() {
      if (this.getUserDetail.role === "admin") {
        this.$router.push("/admin");
      } else {
        this.$router.push("/progress");
      }
    },
    logout() {
      this.$store.dispatch("auth/logout").then(() => {
        this.$router.push("/login");
      });
    },
    closeModal() {
      this.showLoginModal = false;
    },
    setHeaderProperty() {
      window.onscroll = () => {
        // const header = document.getElementById('appHeader')
        // const sticky = header.offsetTop
        // console.log('sticky => ', sticky)
        console.log("page offset => ", window.pageYOffset);
        if (window.pageYOffset > 30) {
          this.isScrolled = true;
        } else {
          this.isScrolled = false;
        }
      };
    },
    goToPage(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style lang="scss">
.app-header {
  //position: fixed;
  //z-index: 100;
  width: 100%;
  .top-header-section {
    background: #f1bc04;
    height: 38px;
    width: 100%;

    .top-header {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .content {
        display: flex;
        gap: 28px;

        .register-action,
        .login-action,
        .profile-action {
          a {
            font-size: 14px;
            text-decoration: none;
            color: #000000;
          }
        }

        #profile-dropdown > button {
          background: transparent !important;
          border: none !important;
          color: #000000 !important;
          outline: none !important;
          box-shadow: none !important;

          &:focus,
          &:hover,
          &:active {
            background: transparent !important;
            border: none !important;
            color: #000000 !important;
            outline: none !important;
            box-shadow: none !important;
          }
        }
      }
    }
  }
  .bottom-header-section {
    //background: transparent;
    //transition: background-color 0.5s;

    .bottom-header {
      padding: 15px 0;
      height: 64px;
      transition: height 0.5s;
      .app-logo {
        cursor: pointer;
      }

      img {
        height: 100%;
        width: auto;
      }

      .content {
        display: flex;
        height: 100%;
        justify-content: space-between;

        .app-nav-wrapper {
          .nav-link {
            color: #ffffff !important;
          }
        }
      }
    }
    .scrolledHeader {
      height: 50px;
      margin-bottom: 10px;
      padding: 6px 0;
      transition: height 1s;
    }
  }
}
@media (max-width: 475px) {
  .app-header {
    .top-header-section {
      height: 38px;

      .top-header {
        .content {
          gap: 18px;

          .register-action,
          .login-action,
          .profile-action {
            a {
              font-size: 11px;
            }
          }
        }
      }
    }
    .bottom-header-section {
      .bottom-header {
        padding: 10px 0;
        height: 64px;
        transition: height 0.5s;

        .content {
          padding: 0 4px;
        }
      }
      .scrolledHeader {
        height: 50px;
        margin-bottom: 10px;
        padding: 6px 0;
        transition: height 1s;
      }
    }
  }
}
</style>
